<template>
  <div class="this-services page">
    <h1 class="title page-title light">{{ $t('services.title') }}</h1>

    <div class="summary">{{ $t('services.summary') }}</div>

    <div class="all">
      <div class="service spec">
        <i class="pi pi-list"></i>

        <h2>{{ $t('services.spec.title') }}</h2>

        <ul>
          <li>{{ $t('services.spec.cdc') }}</li>
          <li>{{ $t('services.spec.proposition') }}</li>
          <li>{{ $t('services.spec.software') }}</li>
          <li>{{ $t('services.spec.conception') }}</li>
        </ul>
      </div>

      <div class="service web">
        <i class="pi pi-globe"></i>

        <h2>{{ $t('services.web.title') }}</h2>

        <ul>
          <li>{{ $t('services.web.management') }}</li>
          <li>{{ $t('services.web.geolocation') }}</li>
          <li>{{ $t('services.web.ad') }}</li>
          <li>{{ $t('services.web.showcase') }}</li>
          <li>{{ $t('services.web.emailAuto') }}</li>
          <li>{{ $t('services.web.internationalisation') }}</li>
        </ul>
      </div>

      <div class="service mobile">
        <i class="pi pi-mobile"></i>

        <h2>{{ $t('services.mobile.title') }}</h2>

        <ul>
          <li>{{ $t('services.mobile.hybrid') }}</li>
          <li>{{ $t('services.mobile.sameWeb') }}</li>
        </ul>
      </div>

      <div class="service back">
        <i class="pi pi-cloud"></i>

        <h2>{{ $t('services.back.title') }}</h2>

        <ul>
          <li>{{ $t('services.back.api') }}</li>
          <li>{{ $t('services.back.jwt') }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Services',
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';
  .this-services {
    display: flex;
    flex-direction: column;
    color: $smoothWhite;

    .title, .summary {
      text-align: center;
    }
    .summary {
      margin-bottom: 75px;
    }

    .all {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      width: 100%;

      .service {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 10px;

        i {
          font-size: 70px;
          width: 120px;
          text-align: center;
          color: $secondaryColor;
          background-color: $mainColor;
          border-radius: 50%;
          padding: 20px;
        }

        h2 {
          color: $mainColor;
          text-align: center;
        }
      }
    }
  }

  /* small to large screen */
  @media (min-width: 640px) {
    .this-services {
      .all {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
    }
  }

  /* mobile */
  @media (max-width: 640px) {
    .this-services {
      .all {
        display: flex;
        flex-direction: column;
      }
    }
  }
</style>
